(function($, w, undefined) {

    function GlobalNav(args, statemanager) {
        console.log('global nav starts');

        this.defaults = {
            btnAccordionTrigger: '.btn-accordion-trigger',
            subNav: '.sub-nav',
            accordionAnimateSpeed: 300
        };

        this.state = {
            open: false
        };

        this.options = $.extend(true, {}, this.defaults, args);
        this.$elem = $('#global-nav');

        if (!this.$elem) {
            return;
        }

        /*
         Define nodes / elements
         */
        var self = this;
        this.$btnAccordionTrigger = $(this.options.btnAccordionTrigger);
        this.activeSubNav = null;

        ///*
        //Bind statemanager events as required
        // */
        MCN.Utility.StateManager.addOnEnter('mobile', function () {
            self.initSubNavAccordions();
        });

        MCN.Utility.StateManager.addOnEnter('desktop', function () {
            self.resetSubNavAccordions();
        });
    }

    GlobalNav.prototype.parent = function(selector) {
        return $(selector, this.$elem);
    };

    GlobalNav.prototype.openNav = function () {
        this.$elem.addClass('open');
        this.state.open = true;
    };

    GlobalNav.prototype.closeNav = function () {
        var self = this;
        if (this.$elem.hasClass('open')) {
            this.$elem.removeClass('open');
            this.state.open = false;
        }

        setTimeout(function () {
            self.closeSubNavAccordion(self.activeSubNav);
        }, 0);
    };


    GlobalNav.prototype.toggleNav = function () {
        if (this.state.open === false) {
            this.openNav();
        } else {
            this.closeNav();
        }
    };


    GlobalNav.prototype.openSubNavAccordion = function (targetSubNav) {
        var openHeight = targetSubNav.attr('data-open-height');
        targetSubNav.attr('style', 'height: ' + openHeight + 'px');
        this.activeSubNav = targetSubNav;

        var arrowIcon = targetSubNav.parent().find('span.icon');
        arrowIcon.removeClass("arrow-down");
        arrowIcon.removeClass("icon-mcn-website-icon-font-arrow-down");
        arrowIcon.addClass("arrow-up");
        arrowIcon.addClass("icon-mcn-website-icon-font-arrow-up");
    };


    GlobalNav.prototype.closeSubNavAccordion = function (targetSubNav) {
        if (targetSubNav) {
            targetSubNav.attr('style', 'height: 0px');
            this.activeSubNav = null;

            var arrowIcon = targetSubNav.parent().find('span.icon');
            arrowIcon.removeClass("arrow-up");
            arrowIcon.removeClass("icon-mcn-website-icon-font-arrow-up");
            arrowIcon.addClass("arrow-down");
            arrowIcon.addClass("icon-mcn-website-icon-font-arrow-down");
        }
    };

    GlobalNav.prototype.toggleSubNavAccordion = function (targetSubNav) {
        if (this.activeSubNav !== null) {

            var isTargetActive = targetSubNav.is(this.activeSubNav);
            if (isTargetActive === true) {
                this.closeSubNavAccordion(targetSubNav);
            } else {
                this.closeSubNavAccordion(this.activeSubNav);
                this.openSubNavAccordion(targetSubNav);
            }
        } else {
            this.openSubNavAccordion(targetSubNav);
        }
    };


    GlobalNav.prototype.initSubNavAccordions = function () {
        var self = this;
        this.$btnAccordionTrigger.each(function (trigger, index) {

            var $subNav = $(this).next();

            if ($subNav) {

                var subNavDefaultHeight = $subNav.offsetHeight;

                $subNav.attr('data-open-height', subNavDefaultHeight);
                $subNav.attr('style', 'height: 0px');

                $(this).on('click', function(){
                    self.toggleSubNavAccordion($subNav);
                });


            } else {
                return;
            }
        });
    };


    GlobalNav.prototype.resetSubNavAccordions = function () {
        this.activeSubNav = null;
        this.$btnAccordionTrigger.each(function (trigger, index) {

            var $subNav = $(this).next();

            if ($subNav) {
                $subNav.attr('style', 'height: auto');

            } else {
                return;
            }
        });
    };

   

    w.MCN = w.MCN || {};
    w.MCN.GlobalNav = GlobalNav;

})(jQuery, window);
